export const peopleRoutes = {
        'Akiva Berkowitz': '/current',
        'Emily Yagoda': '/current',
        'Giorgia Antonia Simboli': '/current',
        'Jayanidhi Kedda': '/current',
        'Melina Lawton': '/current',
        'Molly Acord': '/current',
        'Nagat El Demerdash': '/current',
        'Namrata Darjee': '/current',
        'Tarana Parvez Kaovasia': '/current',
        'Umailla Fatima': '/current',
        'Vismaya Bachu': '/current',
        'Divyaansh Raj': '/current',
        'Miguel Angel Ruiz Cardozo': '/current',
        'Pranjal Agrawal': '/current',
        'Shon Shmushkevich': '/current',
        'Caitlin Kraft': '/current',
        'Chad Caraway': '/current',
        'Ella Reinders': '/current',
        'Griffin Mess': '/current',
        'Jennifer Lee': '/current',
        'Jorge Rodriguez': '/current',
        'Lilia Sukhon': '/current',
        'Navya Kunadi': '/current',
        'Pravarakhya Puppalla': '/current',
        'Princess Naomi Newton': '/current',
        'Rasika Thombre': '/current',
        'Safwan Alomari': '/current',
        'Sarah Abdellah': '/current',
        'Victor Pacis': '/current',
        'Kenae Thompson': '/current',
        'Alec Gonzaga': '/current',
        'Anita Kalluri': '/current',
        'Bruno Gallo': '/current',
        'Min Joon Kim': '/current',
        'Netanel Ben Shalom': '/current',
        'Robert Salkin': '/current',
        'Taylor Anderson': '/current',
        'Hallie Gaitsch': '/current',
        'Adhiraj Chaudhary': '/current',
        'Ahmad Elbeltagy': '/current',
        'Alexandra Jimenez-Hope': '/current',
        'Alexandra Lee': '/current',
        'Arushi Devgun': '/current',
        'Avalon Saja': '/current',
        'Bikona Ghosh': '/current',
        'Eliana Wolf': '/current',
        'Gavin Cressy': '/current',
        'Hasan Slika': '/current',
        'Jackson Miller': '/current',
        'Jennifer Katz': '/current',
        'John Theodore': '/current',
        'Khushi Varshney': '/current',
        'Max Elikan': '/current',
        'Max Goldberg': '/current',
        'Riddhpreet Wahi': '/current',
        'Ruchika': '/current',
        'Sonny Ravinder': '/current',
        'Tatiana Abou Mrad': '/current',
        'Toriyn Dotson': '/current',
        'Adrian Hernandez': '/current',
        'Arham Farooq': '/current',
        'Claudia Viton': '/current',
        'Peter Wang': '/current',
        'Abdelmadjid Dahmani': '/current',
        'Jaiprakash Gurav': '/current',
        'Matthew Kaminski': '/current',
        'Noah Sunshine': '/current',
        'Manthia A. Papageorgakopoulou': '/current',
        'Ruth Glaun': '/current',
        'Shoshana Braverman': '/current',
        'Charlotte Gabriel': '/current',
        'Harshal Shah': '/current',
        'Dania Alsoodany': '/current',
        'Etem Kaan Delibas': '/current',
        'Zeina Housseyki': '/current',
        'Zack McAlister': '/current',
        'Sofie Askin': '/current',
        'Soren Bammens': '/current',
        'Hansika Chennamsetty': '/current',
        'Makayla Biles': '/current',
        'Arman Ataei Kachoei': '/current',
        'Armin Ataei Kachoei': '/current',
        'Leroy Williams': '/alumni2',
        'Alice Huang': '/alumni2',
        'Angela Wu': '/alumni2',
        'Camila Velarde': '/alumni2',
        'Dori Coplon': '/alumni2',
        'Gavin Hsu': '/alumni2',
        'Joe Wooley': '/alumni2',
        'Nancy Abu-Bonsrah': '/alumni2',
        'Neel Ram': '/alumni2',
        'Tula Raghavan': '/alumni2',
        'David Rowshanshad': '/alumni2',
        'Destiny Schriefer': '/alumni2',
        'Iddo Paldor (MD)': '/alumni2',
        'Jood Ali': '/alumni2',
        'MariAngela Pedone': '/alumni2',
        'Sebastian Edwards': '/alumni2',
        'Ann Liu': '/alumni2',
        'Cole Sterling': '/alumni2',
        'David Gullotti': '/alumni2',
        'Eric Sankey': '/alumni2',
        'Fred Lavon': '/alumni2',
        'Leon Pinheiro': '/alumni2',
        'Lindsey Hastings-Spaine': '/alumni2',
        'Maria Veronica Vigilar': '/alumni2',
        'Matteo Turchetti': '/alumni2',
        'Michael Stierer': '/alumni2',
        'Miguel Tyshing': '/alumni2',
        'Nicole Sanchez': '/alumni2',
        'Nitsa Buaron': '/alumni2',
        'Raanan Gurewitsch': '/alumni2',
        'Yuan Wang': '/alumni2',
        'Anjali Shankar': '/alumni2',
        'Francesco Volpin': '/alumni2',
        'Gabrielle Frankel': '/alumni2',
        'Joshua Casaoas': '/alumni2',
        'Julie Sessen': '/alumni2',
        'Madeline Lee': '/alumni2',
        'Maya Takashima': '/alumni2',
        'Mitchell Rock': '/alumni2',
        'Nicolas Skuli': '/alumni2',
        'Raphael Felder': '/alumni2',
        'Roey Reiss': '/alumni2',
        'Shazia Dharssi': '/alumni2',
        'Stasa Tumpa': '/alumni2',
        'Sydney Worsham': '/alumni2',
        'Tarik Lott': '/alumni2',
        'Young Sill Kang (MD)': '/alumni2',
        'John Choi': '/alumni2',
        'Alexander Maynard': '/alumni2',
        'Eileen Xu': '/alumni2',
        'Eric Xu': '/alumni2',
        'Jeff Ehresman': '/alumni2',
        'Luckmini Liyanage': '/alumni2',
        'Madhura Lenninkannan': '/alumni2',
        'Noah Gorelick': '/alumni2',
        'Sharon Xiao Wei': '/alumni2',
        'Ahmed Eltahir': '/alumni2',
        'Arba Cecia': '/alumni2',
        'Audrey Monroe': '/alumni2',
        'Emily Greaves': '/alumni2',
        'Francesca Kroll': '/alumni2',
        'Harrison Baum': '/alumni2',
        'Marisol Doglioli': '/alumni2',
        'Ray Fodor': '/alumni2',
        'Riccardo Serra': '/alumni2',
        'Richard Um': '/alumni2',
        'Sakibul Huq': '/alumni2',
        'Shayan Hemmati': '/alumni2',
        'Stephanie Quintero': '/alumni2',
        'Tejus Pradeep': '/alumni2',
        'Valentina Tagliaferri': '/alumni2',
        'Andy Ding': '/alumni2',
        'Angad Grewal': '/alumni2',
        'Anjali Amiano': '/alumni2',
        'Arman Mizani': '/alumni2',
        'Ashley Yin': '/alumni2',
        'Elizabeth Wicks': '/alumni2',
        'Hanna Antoine': '/alumni2',
        'Joshua Woo': '/alumni2',
        'Kelly Beharry': '/alumni2',
        'Lauren Guttman': '/alumni2',
        'Manuel Morales': '/alumni2',
        'Mason Strazzella': '/alumni2',
        'Nancy Anderson': '/alumni2',
        'Noah Freeman': '/alumni2',
        'Sharmini Premananthan': '/alumni2',
        'Saint Victor Okonma': '/alumni3',
        'Michael Froehler': '/alumni3',
        'Ulrich Thomale': '/alumni3',
        'Natasha Raman': '/alumni3',
        'Benjamin Dorfman': '/alumni3',
        'Kristen Schwab': '/alumni3',
        'Joe Noggle': '/alumni3',
        'Ananth Vellimana': '/alumni3',
        'Satish Misra': '/alumni3',
        'Shira Zeigler': '/alumni3',
        'Eric Momin': '/alumni3',
        'Luca Basaldella': '/alumni3',
        'Abhishek Rege': '/alumni3',
        'Starane Shepherd': '/alumni3',
        'Joshua Kenny': '/alumni3',
        'Rory Petteys': '/alumni3',
        'Harry Brastianos': '/alumni3',
        'Kevin (DingXun) Shao': '/alumni3',
        'Scott Parker': '/alumni3',
        'Lisa Halsbgut': '/alumni3',
        'Vivek Mehta': '/alumni3',
        'Rebecca Abay': '/alumni3',
        'Ali Kooshkabadi': '/alumni3',
        'Rachel Grossman': '/alumni3',
        'Sina Tok': '/alumni3',
        'Katie Snyder': '/alumni3',
        'Lauren Huey': '/alumni3',
        'Kimon Bekelis': '/alumni3',
        'Stefan Ruekriegel': '/alumni3',
        'Samuel Hertig': '/alumni3',
        'Alan Seifert': '/alumni3',
        'Junko Yoshida': '/alumni3',
        'Elizabeth Nance': '/alumni3',
        'Adam Gerber': '/alumni3',
        'Judy Gerstenblith': '/alumni3',
        'Patti Zadnik': '/alumni3',
        'Junichi Yoshimura': '/alumni3',
        'Graeme Woodworth': '/alumni3',
        'Lee Hwang': '/alumni3',
        'David Istkevich': '/alumni3',
        'Yu Ouyang (Charlie)': '/alumni3',
        'Dan Schlattman': '/alumni3',
        'Nishant Kumar': '/alumni3',
        'Stephanie Lin': '/alumni3',
        'Irma Zhang': '/alumni3',
        'Daniel Poliakoff': '/alumni3',
        'Ursalan Khan': '/alumni3',
        'Alp Yurter': '/alumni3',
        'Deven Brown': '/alumni3',
        'Michael Schulman': '/alumni3',
        'Chen Chun (Jenny) Chang': '/alumni3',
        'Javad Azadi': '/alumni3',
        'Peter Gurny': '/alumni3',
        'Robert Wicks': '/alumni3',
        'Kristin Martin': '/alumni3',
        'Uri Hadelsberg': '/alumni3',
        'Khoi Than': '/alumni3',
        'Matthew Bender': '/alumni3',
        'Angelina She': '/alumni3',
        'Marianne Hut': '/alumni3',
        'Nikita Robins': '/alumni3',
        'Carmen Kut': '/alumni3',
        'Momen Sharab (MD)': '/alumni3',
        'Jeanine Reyes': '/alumni3',
        'Luke Murray': '/alumni3',
        'Quinn Salditch': '/alumni3',
        'Noam Schildhaus': '/alumni3',
        'Joanna Xing': '/alumni3',
        'Hansen Bow': '/alumni3',
        'David Santiago-Dieppa': '/alumni3',
        'Maritza Taylor': '/alumni3',
        'Antonella Mangraviti (MD)': '/alumni3',
        'Joshua Watson': '/alumni3',
        'Yike Jin': '/alumni3',
        'Catherine Curtis': '/alumni3',
        'Christopher Polson': '/alumni3',
        'Eliana (Mina) Trink': '/alumni3',
        'Nathan Swedlow': '/alumni3',
        'Nezar Alsaeedi': '/alumni3',
        'Tonya Picker': '/alumni3',
        'MariaLisa Itzoe': '/alumni3',
        'Michael Seng': '/alumni3',
        'Violette Renaud': '/alumni4',
        'Gustavo Pradilla': '/alumni4',
        'Veronica Chiang': '/alumni4',
        'Paolo Rizzo': '/alumni4',
        'Boris Christov': '/alumni4',
        'Yaakov Margulies': '/alumni4',
        'James Frazier': '/alumni4',
        'Paul Wang': '/alumni4',
        'Stephanie Terezakis': '/alumni4',
        'Mary Fran Storm': '/alumni4',
        'Federico Legnani': '/alumni4',
        'Ryan Kretzer': '/alumni4',
        'Alia Hdeib': '/alumni4',
        'Daniel Case': '/alumni4',
        'John Ziewacz': '/alumni4',
        'Jonathan Winter': '/alumni4',
        'Namath Hussain': '/alumni4',
        'Samantha Ford': '/alumni4',
        'Kyle Weaver': '/alumni4',
        'Justin Caplan': '/alumni4',
        'Joram Slager': '/alumni4',
        'Alex Khalessi': '/alumni4',
        'Grettel Zamora': '/alumni4',
        'Adam Carinci': '/alumni4',
        'Priscilla Brastianos': '/alumni4',
        'Raqeeb Haque': '/alumni4',
        'Rory Goodwin': '/alumni4',
        'Shaan Raza': '/alumni4',
        'Urvashi Uphadhyay': '/alumni4',
        'Wesley Hsu': '/alumni4',
        'Pablo Recinos': '/alumni4',
        'Adam Fisch': '/alumni4',
        'Yuval Zohar': '/alumni4',
        'Sarah Brem': '/alumni4',
        'Sarah Posner': '/alumni4',
        'Brandon Togioka': '/alumni4',
        'James Lee': '/alumni4',
        'Gaurav Mavinkurve': '/alumni4',
        'Marilyn Perez': '/alumni4',
        'Min-Hee Cho': '/alumni4',
        'Christopher Long': '/alumni4',
        'Neha Gosalia': '/alumni4',
        'Alessandro Fiorindi': '/alumni4',
        'Celina Martinez': '/alumni4',
        'Jonathan Pindrik': '/alumni4',
        'Kent Werner': '/alumni4',
        'Stacey Wang': '/alumni4',
        'Tiffany Williams': '/alumni4',
        'Christina LaDana': '/alumni4',
        'Margaret Baker': '/alumni4',
        'Sandya Nair': '/alumni4',
        'Priscilla Pang': '/alumni4',
        'Markus Bookland': '/alumni4',
        'William Pennant': '/alumni4',
        'Aamir Abbas': '/alumni4',
        'Jaishri Blakely (M.D.)': '/alumni4',
        'Johnny Sobotie': '/alumni4',
        'Jay Steven Reidler': '/alumni4',
        'Judith Vick': '/alumni4',
        'Rounak Nande': '/alumni4',
        'Carlo Passeri': '/alumni4',
        'Andrey Volkov': '/alumni4',
        'Frank Attenello': '/alumni4',
        'Kenneth Tseng': '/alumni4',
        'Timothy Jansen': '/alumni4',
        'Rafael Tamargo (Jr.)': '/alumni4',
        'Jessica Pearlman': '/alumni4',
        'Tristan Stani': '/alumni4',
        'Thomas Pashalides': '/alumni4',
        'Jorge Alvernia': '/alumni4',
        'Edgar Lee': '/alumni4',
        'Julie Allen': '/alumni4',
        'Lindsay Sukay': '/alumni4',
        'James Han': '/alumni4',
        'Zehava Moskowitz': '/alumni4',
        'Abhishek Kumar': '/alumni4',
        'John Hermann': '/alumni4',
        'Gary Kao': '/alumni4',
        'Sarah Gearhart': '/alumni4',
        'Neena Marupudi': '/alumni4',
        'Kaisorn Chaichana': '/alumni4',
        'Hasan Zaidi': '/alumni4',
        'Sahael Stapleton': '/alumni4',
        'Sameer Kaiser': '/alumni4',
        'Thomas Kosztowksi': '/alumni4',
        'Sophia Shakur': '/alumni4',
        'Sam Schulman': '/alumni4',
        'Shahbaz Ali Malik': '/alumni4',
        'James Han': '/alumni4',
        'Richard Clatterbuck': '/alumni5',
        'Mark Watts': '/alumni5',
        'Darin Epstein': '/alumni5',
        'Hamid Yazdi': '/alumni5',
        'John Crongeyer': '/alumni5',
        'Paul Cohen': '/alumni5',
        'Richard Anderson': '/alumni5',
        'Karlijn Van Wessem': '/alumni5',
        'Kelly Babel': '/alumni5',
        'Xue Ming': '/alumni5',
        'Justin Hanes': '/alumni5',
        'Eric Oshiro, MD': '/alumni5',
        'Amer Samdani': '/alumni5',
        'Jennifer Pai': '/alumni5',
        'Kwang-Wook Suh': '/alumni5',
        'Martin Burke': '/alumni5',
        'Prakash Sampath': '/alumni5',
        'David Sandberg': '/alumni5',
        'Quoc-Anh Thai': '/alumni5',
        'Johnny Sandhu': '/alumni5',
        'Neal Naff (MD)': '/alumni5',
        'Francesco DiMeco': '/alumni5',
        'Anjali Aggarwal': '/alumni5',
        'Laurence Rhines': '/alumni5',
        'Victor Perry': '/alumni5',
        'Adam Geyer': '/alumni5',
        'Kathleen Bruno': '/alumni5',
        'Kenji Muro': '/alumni5',
        'Michael Gayles': '/alumni5',
        'Vance Vanier': '/alumni5',
        'Eric Amundson': '/alumni5',
        'Sander Beekmans': '/alumni5',
        'David Antezana': '/alumni5',
        'Raymond Haroun': '/alumni5',
        'Sarvenaz Zand': '/alumni5',
        'Christopher Lawson': '/alumni5',
        'Matthew Wetzel': '/alumni5',
        'Simone Betchen': '/alumni5',
        'Andrew Chang': '/alumni5',
        'Chidi Mgwaba': '/alumni5',
        'Khan Li': '/alumni5',
        'Chetan Bettegowda': '/alumni5',
        'Berhane Worku': '/alumni5',
        'Jeannette Liu': '/alumni5',
        'Luca Denaro': '/alumni5',
        'John Reavey-Cantwell': '/alumni5',
        'Piyush Banker': '/alumni5',
        'Patrik Gabikian': '/alumni5',
        'Brendan Lucey': '/alumni5',
        'Travis Tierney': '/alumni5',
        'Vivian Tsai': '/alumni5',
        'Jacqueline Garonzik': '/alumni5',
        'Maciej (Matt) Lesniak': '/alumni5',
        'Catalino Dureza': '/alumni6',
        'Peter Oishi': '/alumni6',
        'Taras Masnyk': '/alumni6',
        'David Lowry': '/alumni6',
        'Kevin Judy': '/alumni6',
        'Ali Mesiwala': '/alumni6',
        'Kee Kim': '/alumni6',
        'Young-Chun Park': '/alumni6',
        'Mike Froehler': '/alumni6',
        'Jon Weingart': '/alumni6',
        'Kwame G. Buahin': '/alumni6',
        'Mitchell Cahan': '/alumni6',
        'Jonathan Baskin': '/alumni6',
        'Peter Gerszten': '/alumni6',
        'John Davis': '/alumni6',
        'Betty Tyler': '/alumni6',
        'Omar Jimenez': '/alumni6',
        'Oneida Arosarena': '/alumni6',
        'Kevin Walter': '/alumni6',
        'Bala Giri': '/alumni6',
        'William Johnson (Blake)': '/alumni6',
        'Robert Zev Raden': '/alumni6',
        'Eric Sipos': '/alumni6',
        'Tadanobu Utsuki': '/alumni6',
        'Reid Thompson': '/alumni6',
        'Benjamin T. White': '/alumni6',
        'Timothy Witham': '/alumni6',
        'Graham Gardner': '/alumni6',
        'Philip Hodge': '/alumni6',
        'Mary Wu': '/alumni6',
        'Phillip B. Storm (Jay)': '/alumni6',
        'Khosrow Tabassi': '/alumni6',
        'Michael Gibbons (Chris)': '/alumni6',
        'Matthew Ewend': '/alumni6',
        'Allen Sills': '/alumni6',
        'Merhrdad (Mark) Mofid': '/alumni6',
        'Matthew Pearson': '/alumni6',
        'Ilana Lavana': '/alumni6',
        'Henry Brem': '/alumni7',
        'Ken Blumenfeld': '/alumni7',
        'Chris Guerin': '/alumni7',
        'Rafael Tamargo': '/alumni7',
        'Andy Levy': '/alumni7',
        'Damirez Fossett': '/alumni7',
        'Doug MacKenzie': '/alumni7',
        'Michael Yang': '/alumni7',
        'John Myseros': '/alumni7',
        'Robert Bok': '/alumni7',
        'Alessandro Olivi': '/alumni7',
        'Doris Lenartz': '/alumni7',
        'Takahiro (Taka) Tsuchida': '/alumni7',
        'Michael Lawton': '/alumni7',
    };